module.exports = __webpack_public_path__ + "static/media/banner01.85e5d07f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/medias/banner01.jpg
// module id = 137
// module chunks = 0